import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  mobileFsOpener: 'data-mobile-fs-opener',
  mobileFacetsHeading: 'data-mobile-facets-heading',
}
const qsAll = {
  
}

const openFSPanel = (event) => {
  const details = event.target.closest('details').querySelectorAll('details')
  details.forEach((detail) => {detail.setAttribute('open', '')
  detail.classList.add('menu-opening')})
}

const mobileFacetHeadingEvent = () => {
  const mobileFilterDrawer = dom.mobileFacetsHeading.closest('menu-drawer').querySelector('details.disclosure-has-popup')
  mobileFilterDrawer.classList.remove('menu-opening')
  mobileFilterDrawer.removeAttribute('open')
  document.querySelector('body').classList.remove('overflow-hidden-mobile')
}

export const setupCollectionAdditionals = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.mobileFsOpener) {
    dom.mobileFsOpener.addEventListener('click', openFSPanel)
    dom.mobileFsOpener.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        openFSPanel(e) 
      }
    })
  }
  if(dom.mobileFacetsHeading) {
    dom.mobileFacetsHeading.addEventListener('click', () => {
      mobileFacetHeadingEvent()
    })
    dom.mobileFacetsHeading.addEventListener('keydown', () => {
      if (e.key === 'Enter') {
        mobileFacetHeadingEvent()
      }
    })
  }
}